module.exports = __webpack_public_path__ + "media/images/smart_phone/projects_change/ico_choice-on-2bd862f16aa18954269ff2d8e0e668e9.png";